const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i;

export function isMobileDevice() {
    if (typeof navigator === 'undefined') {
        return false;
    }

    return MOBILE_USER_AGENT.test(navigator.userAgent || '');
}
